import { z } from 'zod';
import { BaseApplicationDTOSchema, } from "./applications.dto.js";
export const ReleaseApplicationHandoffRequestDTOSchema = z.object({
    params: z.object({
        companyId: BaseApplicationDTOSchema.shape.companyId,
        facilityId: BaseApplicationDTOSchema.shape.facilityId,
        applicationId: BaseApplicationDTOSchema.shape.id,
    }),
});
//# sourceMappingURL=release-application-handoff.dto.js.map